import React from 'react';
import About from '../components/About';
import NextSupplySection from '../components/NextSupplySection';
import Sustainability from '../components/Sustainability';

const AboutPage = () => {
  return (
    <div>
      <About />
      <NextSupplySection />
      <Sustainability />
    </div>
  );
};

export default AboutPage;

